// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Eight Sparks",
  id: "eight-sparks",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire","spark","wait","aim"],
    icon: {
      "backgroundColor": 4526607,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -4,
          "color": 16757088
        },
        {
          "iconKey": "lightning",
          "position": {
            "x": 17,
            "y": -1
          },
          "scale": 0.56,
          "rotation": -14,
          "color": 15126303
        },
        {
          "iconKey": "aim",
          "position": {
            "x": -9,
            "y": 14
          },
          "scale": 0.65,
          "rotation": -8,
          "color": 15663103
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -6,
            "y": -12
          },
          "scale": 0.61,
          "rotation": 0,
          "color": 16773375
        }
      ]
    },
  },
};

export default metadata;
